import { render, staticRenderFns } from "./participant-focus.vue?vue&type=template&id=0f5011c9&"
import script from "./participant-focus.vue?vue&type=script&lang=js&"
export * from "./participant-focus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "participant-focus.vue"
export default component.exports